import type { PageHeaderBackTo } from './types'

export const addSearchParams = (to: PageHeaderBackTo, search: string): PageHeaderBackTo => {
  if (search.length === 0) {
    return to
  }

  // Append search params using the correct separator for the target URL.
  return `${to}${to.includes('?') ? '&' : '?'}${search}`
}
